// WS #2228906 (tester, 10-15): "maybe name it so it's clearer what's inside". An e-signed document's type
// is the generic "E-signed Doc", and the list does not even load it, so the Type cell was blank for every
// LSA, PCA, POA and card authorization. What the document is lives in typeDoc. Behind ESIGN_DOC_NAMES.
const NAMES = {
  legalServiceAgreement: 'Legal Services Agreement',
  legalServiceAgreementSpanish: 'Legal Services Agreement (bilingual)',
  pca: 'Payment Change Addendum',
  poa: 'Power of Attorney',
  'Power of Attorney': 'Power of Attorney',
  'revoked-poa': 'Revoked Power of Attorney',
  cardAuthorization: 'Card Payment Authorization',
}

const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

export const isEsignedRow = (row) => row?.__t === 'SignDocument'

// The name for an e-signed row; documents older than typeDoc get a generic one rather than a blank.
export const esignDocName = (row) => {
  const name = NAMES[row?.typeDoc] || 'E-signed document'
  const amount = Number(row?.cardAuth?.amount)
  return row?.typeDoc === 'cardAuthorization' && Number.isFinite(amount) && amount > 0
    ? `${name} · ${money.format(amount)}`
    : name
}
